import type { DashboardPeriod } from '~/app/services/organization-manager-dashboard/organization-manager-dashboard.types';
import { chargingKpisForPeriod } from './charging-kpi.mock';
import type { GetChargingKpisResponseDto } from './charging-kpi.types';

/**
 * Charging KPIs for the operator dashboard and service-quality screens.
 *
 * Today: typed mock so the screens render before the charging KPI route is on main.
 * Later: replace `getKpis` with fetch / generated client — keep the DTO
 * and pass `period` as a query param.
 */
export const ChargingKpiService = {
  async getKpis(period: DashboardPeriod): Promise<GetChargingKpisResponseDto> {
    await new Promise((resolve) => setTimeout(resolve, 150));
    return chargingKpisForPeriod(period);
  },
};
